import * as React from "react";
import {
  Create,
  ImageField,
  ImageInput,
  NumberInput,
  required,
  SimpleForm,
  TextInput,
  TranslatableInputs,
} from "react-admin";
import { locales } from "../enum/locales";

export const PartnersCreateForm = () => (
  <SimpleForm>
    <ImageInput source="file" label="Partner image" validate={[required()]}>
      <ImageField source="src" title="title" />
    </ImageInput>
    <TranslatableInputs locales={locales} defaultLocale="en" fullWidth={true}>
      <TextInput source="title" validate={[required()]} fullWidth={true} />
    </TranslatableInputs>
    <NumberInput source="position" validate={[required()]} defaultValue={0} />
  </SimpleForm>
);

export const PartnersCreate = () => (
  <Create>
    <PartnersCreateForm />
  </Create>
);
